import { type UserListInput, type SmallUser, type UserListSuccess } from '@terros/common'
import { useTantalimQuery } from '../query'
import { userListKey } from '../keys'
import { type GetHookResponse } from '../hooks'
import { useUserCache } from './cache'

export function useUsers(input: UserListInput = {}, enabled = true): GetHookResponse<SmallUser[]> {
  const cache = useUserCache()
  return useTantalimQuery<UserListInput, UserListSuccess, SmallUser[]>({
    url: '/user/list',
    queryKey: userListKey(input),
    input,
    convertResponse: (data) => {
      data.users.forEach((user) => {
        cache.setTinyUser(user)
      })
      return data.users
    },
    options: {
      enabled,
    },
  })
}
